import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import type { Database } from "@copro/api";
import { keys } from "./keys";

type Command = Database['public']['Tables']['documents']['Update'];

async function updateDocument(id: string, command: Command) {
  const { data, error } = await apiClient
    .from('documents')
    .update(command)
    .eq('id', id)
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
}

type Variables = {
  id: string;
  command: Command;
}

export default function useUpdateDocument() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, command }: Variables) => updateDocument(id, command),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.documents });
    },
  });
}
